import { useEffect } from 'react';

interface KeyboardShortcuts {
  onSearchOpen?: () => void;
  onEscape?: () => void;
}

export const useKeyboardShortcuts = ({ onSearchOpen, onEscape }: KeyboardShortcuts) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Cmd/Ctrl + K for search
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        onSearchOpen?.();
        return;
      }

      // Escape key
      if (event.key === 'Escape') {
        event.preventDefault(); 
        onEscape?.();
        return;
      }

      // Prevent search shortcut when typing in inputs
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        (event.target as HTMLElement)?.isContentEditable
      ) {
        return;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onSearchOpen, onEscape]);
};